module.exports = __webpack_public_path__ + "img/44.617c2c8.jpg";